<template>
  <b-container fluid class="legal-page px-0">
    <section class="legal-hero">
      <b-container>
        <b-row>
          <b-col cols="12" lg="10" class="mx-auto">
    <div class="legal-hero-inner">
      <!-- <p class="eyebrow mb-2">LEGAL</p> -->
      <h1 class="legal-title mb-3">Privacy Policy</h1>
      <p class="legal-desc mb-0">
              This Privacy Policy explains how Floating Knight Biotech collects,
              uses, and protects personal data in connection with the
              silver bullet® website.
            </p></div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="legal-section">
      <b-container>
        <b-row>
          <b-col cols="12" lg="10" xl="9" class="mx-auto">
            <div class="legal-card">
              <p class="last-updated mb-4">
                <strong>Last updated:</strong> 10/03/2026
              </p>

              <div class="legal-block">
                <p>
                  This Privacy Policy explains how
                  <strong>Floating Knight Biotech</strong>, owner of the
                  <strong>silver bullet<sup>®</sup></strong> brand (“we”, “us”, or “our”),
                  collects, uses, and protects personal data when you visit this
                  website or contact us through it.
                </p>
                <p class="mb-0">
                  We are committed to handling personal data responsibly and, where
                  applicable, in accordance with relevant data protection laws,
                  including the General Data Protection Regulation (GDPR).
                </p>
              </div>

              <div class="legal-block">
                <h2>1. Personal Data We May Collect</h2>
                <p class="mb-2">We may collect and process personal data such as:</p>
                <ul class="legal-list mb-0">
                  <li>name</li>
                  <li>email address</li>
                  <li>company name</li>
                  <li>country or region</li>
                  <li>business type</li>
                  <li>product interest</li>
                  <li>message or inquiry content</li>
                  <li>other information voluntarily submitted by you</li>
                </ul>
              </div>

              <div class="legal-block">
                <h2>2. How We Collect Data</h2>
                <p class="mb-0">
                  We collect personal data when you submit a contact or inquiry
                  form, contact us by email, or otherwise communicate with us
                  through this website.
                </p>
              </div>

              <div class="legal-block">
                <h2>3. How We Use Personal Data</h2>
                <p class="mb-2">We may use personal data to:</p>
                <ul class="legal-list mb-0">
                  <li>respond to your inquiries</li>
                  <li>communicate with you regarding your request</li>
                  <li>evaluate potential business cooperation</li>
                  <li>maintain internal communication records</li>
                  <li>protect website security and prevent misuse</li>
                  <li>comply with legal or regulatory obligations</li>
                </ul>
              </div>

              <div class="legal-block">
                <h2>4. Legal Basis for Processing</h2>
                <p class="mb-0">
                  Where applicable under GDPR, our legal bases for processing may
                  include your consent, our legitimate interests in responding to
                  business inquiries and operating our website, and compliance
                  with legal obligations.
                </p>
              </div>

              <div class="legal-block">
                <h2>5. Sharing of Personal Data</h2>
                <p class="mb-0">
                  We do not sell personal data. We may share personal data only
                  where necessary with website hosting providers, form or email
                  service providers, professional advisers, or competent
                  authorities where required by law.
                </p>
              </div>

              <div class="legal-block">
                <h2>6. International Transfers</h2>
                <p class="mb-0">
                  Personal data may be processed in countries outside your own
                  jurisdiction, including where our service providers operate.
                  Where required, appropriate safeguards will be used in
                  connection with such transfers.
                </p>
              </div>

              <div class="legal-block">
                <h2>7. Data Retention</h2>
                <p class="mb-0">
                  We retain personal data only for as long as reasonably
                  necessary for the purposes described in this Privacy Policy,
                  including responding to inquiries, maintaining business
                  records, and complying with legal obligations.
                </p>
              </div>

              <div class="legal-block">
                <h2>8. Your Rights</h2>
                <p class="mb-2">
                  Where applicable, you may have the right to:
                </p>
                <ul class="legal-list mb-0">
                  <li>request access to your personal data</li>
                  <li>request correction of inaccurate data</li>
                  <li>request deletion of your data</li>
                  <li>request restriction of processing</li>
                  <li>object to certain processing</li>
                  <li>request data portability</li>
                  <li>withdraw consent where processing is based on consent</li>
                  <li>lodge a complaint with a competent supervisory authority</li>
                </ul>
              </div>

              <div class="legal-block">
                <h2>9. Data Security</h2>
                <p class="mb-0">
                  We take reasonable technical and organizational measures to
                  protect personal data against unauthorized access, disclosure,
                  alteration, or destruction. However, no method of transmission
                  or storage is completely secure.
                </p>
              </div>

              <div class="legal-block">
                <h2>10. Cookies and Tracking</h2>
                <p class="mb-0">
                  This website is currently primarily informational. If cookies,
                  analytics, or similar tracking technologies are used, they
                  should be described in a separate Cookie Policy or in an
                  updated version of this Privacy Policy.
                </p>
              </div>

              <div class="legal-block">
                <h2>11. Third-Party Websites</h2>
                <p class="mb-0">
                  This website may contain links to third-party websites. We are
                  not responsible for the content or privacy practices of
                  third-party websites.
                </p>
              </div>

              <div class="legal-block">
                <h2>12. Children</h2>
                <p class="mb-0">
                  This website is intended for general informational and business
                  use and is not directed to children. We do not knowingly
                  collect personal data from children through this website.
                </p>
              </div>

              <div class="legal-block">
                <h2>13. Changes to This Privacy Policy</h2>
                <p class="mb-0">
                  We may update this Privacy Policy from time to time. Any
                  updated version will be posted on this page with a revised
                  “Last updated” date.
                </p>
              </div>

              <div class="legal-block mb-0">
                <h2>14. Contact</h2>
                <p class="mb-1">Floating Knight Biotech</p>
                <p class="mb-1">Brand: silver bullet<sup>®</sup></p>
                <p class="mb-1">Email: info@floatingknight.com</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </b-container>
</template>

<script>
export default {
  name: "Privacy",

};
</script>

<style scoped>
.legal-page {
  background: transparent;
  color: #1f1f1a;
}

.legal-hero {
  padding: 44px 0 20px;
}

.eyebrow {
  font-size: 0.74rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #7b7a72;
  font-weight: 600;
}

.legal-title {
  font-size: 2.2rem;
  line-height: 1.08;
  letter-spacing: -0.02em;
  font-weight: 600;
  color: #1e1f1a;
  margin: 0;
}

.legal-desc {
  font-size: 0.96rem;
  line-height: 1.55;
  color: #66685f;
  max-width: 760px;
}

.legal-section {
  padding: 8px 0 52px;
}

.legal-card {
  border: 1px solid rgba(70, 70, 55, 0.08);
  border-radius: 22px;
  padding: 30px 32px;
  box-shadow: 0 14px 36px rgba(40, 42, 33, 0.04);
  background: transparent;
  max-width: 860px;
  margin: 0 auto;
}

.last-updated {
  font-size: 0.9rem;
  color: #6b6d64;
}

.legal-block {
  padding-top: 18px;
  margin-top: 18px;
  border-top: 1px solid rgba(70, 70, 55, 0.08);
}

.legal-block:first-of-type {
  padding-top: 0;
  margin-top: 0;
  border-top: 0;
}

.legal-block h2 {
  font-size: 1.02rem;
  line-height: 1.35;
  font-weight: 600;
  color: #20211c;
  margin-bottom: 8px;
}

.legal-block p,
.legal-list li {
  font-size: 0.94rem;
  line-height: 1.7;
  color: #5f6159;
}

.legal-list {
  padding-left: 1.2rem;
}

@media (max-width: 991.98px) {
  .legal-hero {
    padding: 36px 0 16px;
  }

  .legal-title {
    font-size: 1.9rem;
  }

  .legal-card {
    padding: 24px 20px;
    border-radius: 18px;
  }
}

.legal-hero-inner {
  max-width: 860px;
  margin: 0 auto;
}

.legal-title,
.legal-desc,
.eyebrow {
  text-align: left;
}

.legal-card {
  max-width: 860px;
  margin: 0 auto;
}
</style>